import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LearnProvider, useLearn } from "@/contexts/LearnContext";
import Layout from "@/components/Layout";
import WelcomePage from "@/pages/WelcomePage";
import HomePage from "@/pages/HomePage";
import ModulePage from "@/pages/ModulePage";

import { Toaster } from "@/components/ui/sonner";

function Gate({ children }) {
  const { user, loading } = useLearn();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}



function AppRoutes() {
  const { user } = useLearn();
  return (
    <Routes>
      <Route
        path="/"
        element={user ? <Navigate to="/home" replace /> : <WelcomePage />}
      />
      <Route
        path="/home"
        element={
          <Gate>
            <Layout>
              <HomePage />
            </Layout>
          </Gate>
        }
      />
      <Route
        path="/module/:moduleId"
        element={
          <Gate>
            <Layout>
              <ModulePage />
            </Layout>
          </Gate>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {

  useEffect(() => {
    // If the window is not inside an iframe (top window), redirect to LMS
    if (window.self === window.top) {
      window.location.href = "https://learninghub.steadfastitconsulting.com/login";
    }
  }, []);

  return (
    <div className="App">
      <LearnProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </LearnProvider>
    </div>
  );
}

export default App;
